import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';

export const msalEventCallbackHandler = (event: EventMessage, msalInstance: PublicClientApplication) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
};
